import { authUtilityLoader } from '@consumer/auth-utility-loader';
import { eventBus } from "../../../../eventBus/eventBus";
export const signOut = async () => {
  const {
    signOut: authUtilitySignOut
  } = await authUtilityLoader();
  await authUtilitySignOut();
};
export const getConsumerId = async () => {
  const {
    getConsumerId: authUtilGetConsumerId
  } = await authUtilityLoader();
  await authUtilGetConsumerId();
};
export const getIdToken = async () => {
  const {
    getIsUserSignedIn,
    cognitoIdToken
  } = await authUtilityLoader();
  const updatedIsUserSignedIn = await getIsUserSignedIn();
  const token = updatedIsUserSignedIn ? await cognitoIdToken() : '';
  return token;
};
export const showAuthModal = async params => {
  const {
    showAuthModal
  } = await authUtilityLoader();
  return showAuthModal(params);
};
export const publishFetchProfileData = () => {
  eventBus.publish('userProfile.fetchProfileData');
};